import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ApiService, AuthService } from '@solcre-org/core';
import {
  AlertContainerComponent,
  CoreUiTranslateService,
  LoaderComponent,
} from '@solcre-org/core-ui';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    AlertContainerComponent,
    CommonModule,
    LoaderComponent,
  ],
  templateUrl: './app.html',
})
export class App {
  private coreUiTranslateService: CoreUiTranslateService = inject(
    CoreUiTranslateService
  );
  private apiService: ApiService = inject(ApiService);
  private authService: AuthService = inject(AuthService);

  constructor() {
    this.setDefaultLanguage();

    // Watch state change
    this.authService.onAccessTokenRefreshed.subscribe((newToken: any) => {
      if (newToken.token) {
        this.apiService.setAccessToken(newToken.token);
      }
    });
  }

  private setDefaultLanguage(): void {
    this.coreUiTranslateService.initialize('en');
  }
}
